import { TotvsNotificationType } from './totvs-notification-type';
export interface TotvsNotificationOptions {
	duration?: number;
	actionButtonText?: string;
	actionButton?: Function;
	type?: TotvsNotificationType;
}